/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const openPositionMembershipEntrySchema = z.object({
  commitment: z.number().min(0).max(1),
  endDate: z.iso.date().nullish(),
  startDate: z.iso.date().nullish(),
  teamId: z.int(),
});
